import { PaymentType } from '@/features/graphql/generated/graphql'

export const OPEN_ACCOUNT_NAME_MAX_LENGTH = 120

export const SUPPORTED_ACCOUNT_PAYMENT_METHODS = [
    PaymentType.Cash,
    PaymentType.CardOnsite,
    PaymentType.MealVoucher,
    PaymentType.MealVoucherCard,
] as const
